import {
  OutlinedInput,
  Select,
  MenuItem,
  SelectChangeEvent,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import CasControl from '../CasControl/CasControl';


/*
  CasSelect intentionally does not support multiple props. It is for a single value.
  (If we need multiple=true in the future, we'll implement a separate component wrapper.)
*/

export interface ICasSelect {
  value: string;
  label: string;
  onChange: (event: SelectChangeEvent<any>, value: string) => void;
  placeholder?: string;
  name?: string;
  options: any[];
  optionsNameField?: string;
  optionsIdField?: string;
  emptyMessage?: string;
  sx?: SxProps<Theme>;
  className?: string;
}

const CasSelect = ({
  className,
  label,
  value,
  onChange,
  placeholder,
  name,
  options,
  optionsNameField = 'name',
  optionsIdField = 'id',
  emptyMessage,
  sx
}: ICasSelect) => {
  if (emptyMessage && options.length === 0) {
    return (
      <Typography color="#637381" fontStyle="italic">
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <CasControl label={label} shrink={value !== undefined && value !== "" }>
      <Select
        displayEmpty={options.some(option => option[optionsIdField] === null)}   // allow treating null option as value when null option is provided.
        className={className}
        value={value}
        name={name}
        onChange={(event) => onChange(event, event.target.value)}
        input={<OutlinedInput label={placeholder} />}
        MenuProps={{
          PaperProps: {
            sx: { maxHeight: 240 },
          },
        }}
        sx={sx}
      >
        {options.map((option: any) => (
          <MenuItem key={option[optionsIdField]} value={option[optionsIdField]}>
            {option[optionsNameField]}
          </MenuItem>
        ))}
      </Select>
    </CasControl>
  );
};

export default CasSelect;
